import { render, staticRenderFns } from "./ContentService.vue?vue&type=template&id=01999260&"
import script from "./ContentService.vue?vue&type=script&lang=js&"
export * from "./ContentService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports